import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    docsUpdateForm,
    docsStore,
    docsResetForm,
    publicLoadDocsItem,
    publicDelTempUploadItem,
    publicDelUploadItem
} from '../actions/docs'
import AdminDocsFormComponent from '../components/AdminDocsForm'
import LoadingComponent from '../components/Loading'
import DeniedComponent from '../components/Denied'
import Permissions from '../models/Permissions'

class AdminDocsForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        this.setState({loading: true})
        this.props.loadOwnItem(this.props.match.params.id)
    }

    componentWillReceiveProps(nextProps) {
        var routeId = nextProps.match.params.id || ''
        var lastRouteId = this.props.match.params.id || ''
        if (routeId !== lastRouteId) {
            this.setState({loading: true})
            this.props.loadOwnItem(routeId)
        } else if (this.props.data.id !== nextProps.data.id) {
            this.setState({loading: true})
            this.props.loadOwnItem(nextProps.data.id)
        } else {
            this.setState({loading: false})
        }
    }

    render() {
        if (this.state.loading) return (<LoadingComponent />)
        if (this.props.data.id) {
            if (Permissions.isDenied('docs', 'update', this.props.data)) return <DeniedComponent />
        } else if (Permissions.isDenied('docs', 'create')) return <DeniedComponent />
        return (<AdminDocsFormComponent {...this.props} />)
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.docs)
    nextProps['auth'] = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadOwnItem: (id) => {
            dispatch(publicLoadDocsItem(id))
        },
        updateForm: (formData) => {
            dispatch(docsUpdateForm(formData))
        },
        storeForm: (formData, b) => {
            dispatch(docsStore(formData))
        },
        resetForm: () => {
            dispatch(docsResetForm())
        },
        removeFile: (item) => {
            dispatch(publicDelUploadItem(item))
        },
        removeUpload: (item) => {
            dispatch(publicDelTempUploadItem(item))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDocsForm)



// WEBPACK FOOTER //
// ./src/containers/AdminDocsForm.js